export default "__VITE_ASSET__bHk3Lzlg__"